import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-radio-form-field',
  standalone: true,
   imports: [CommonModule, ReactiveFormsModule, TranslateModule, InputHelperTextComponent],
  templateUrl: './radio-form-field.component.html',
  styleUrl: './radio-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioFormFieldComponent),
      multi: true,
    },
  ],
})
export class RadioFormFieldComponent {
  @Input() options: { label: string; value: any }[] = [];
  @Input() viewMode!: boolean;
  @Input() label!: string;
  @Input() isRequired!: boolean;
  @Input() helpText!: string;
  @Input() name!: string;
  @Output() onSelectionChange = new EventEmitter<any>();

  formControl: FormControl = new FormControl<any>(null);
  private unsubscribe$ = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  onTouch: () => void = () => {};
  onChange: (value: any) => void = () => {};

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: any): void {
    this.formControl.setValue(value, { emitEvent: false });
    this.changeDetectorRef.markForCheck();
  }

  get selectedLabel(): string | undefined {
    return this.options.find(option => option.value === this.formControl.value)?.label;
  }

  ngOnInit(): void {
    this.formControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      this.onSelectionChange.emit(value);
      this.onChange(value);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
